import {Component, Input, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import {Aangifte, BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-woning-overig',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tekst-woning-overig.component.html',
  styleUrl: './tekst-woning-overig.component.scss',
})
export class TekstWoningOverigComponent implements OnInit {

@Input() public id!: string;
public ibAangifte = {} as Aangifte;
public focusedElementId: string | null = null;
public year = 2024;
public actualYear: number = new Date().getFullYear();

  constructor(
      public dataService: BokkzIbDataService) {
  }

  ngOnInit(): void {
    this.dataService.incomeTaxEntity.subscribe((value) => {
      if (value.year !== undefined) {
        this.year = value.year;
      }
    })
  }

}
